export default "__VITE_ASSET__BXo_sp_O__"